import { ChangeEvent, ComponentType } from "react";

import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import DeleteForeverOutlinedIcon from "@mui/icons-material/DeleteForeverOutlined";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import FactCheckOutlinedIcon from "@mui/icons-material/FactCheckOutlined";
import PendingOutlinedIcon from "@mui/icons-material/PendingOutlined";
import { Box, Grid, MenuItem } from "@mui/material";
import { SvgIconProps } from "@mui/material/SvgIcon";
import { useContextContrato } from "src/Contexts/Lancamentos/Contrato/ContratosContext";
import { ICancelarContrato } from "src/Contexts/Lancamentos/Contrato/ContratosTypes";
import { AppTextField } from "src/Pages/components";

type StatusOption = {
  value: ICancelarContrato["status"];
  label: string;
  Icon: ComponentType<SvgIconProps>;
};

const STATUS_SELECT_OPTIONS: StatusOption[] = [
  { value: "APPROVED", label: "Aprovado", Icon: CheckCircleOutlineIcon },
  { value: "PENDING", label: "Pendente", Icon: PendingOutlinedIcon },
  { value: "VALIDATION", label: "Validação", Icon: FactCheckOutlinedIcon },
  { value: "CANCELLED", label: "Cancelar - Manter parcelas abertas", Icon: CancelOutlinedIcon },
  { value: "CANCELAR_DELETAR_PARCELAS", label: "Cancelar - Deletar parcelas abertas", Icon: DeleteForeverOutlinedIcon, },
  { value: "NAO_EFETIVADO", label: "Não efetivado - Deletar parcelas", Icon: DeleteOutlineIcon, },

];

const menuItemWithIcon = (opt: StatusOption) => {
  const Icon = opt.Icon;
  return (
    <Box
      component="span"
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1,
        width: "100%",
        fontSize: "0.9rem",
      }}
    >
      <Icon sx={{ opacity: 0.9, fontSize: "1rem" }} />
      {opt.label}
    </Box>
  );
};

export const FormStatusContrato = () => {
  const { valuesInputCancelarContrato, setValuesInputCancelarContrato } =
    useContextContrato();

  const handleChange =
    (prop: keyof ICancelarContrato) =>
      (event: ChangeEvent<HTMLInputElement>) => {
        setValuesInputCancelarContrato((prevValue) => ({
          ...prevValue,
          [prop]: event.target.value,
        }));
      };

  return (
    <Grid container spacing={4} sx={{ mb: "1rem" }}>
      <Grid item xs={5}>
        <AppTextField
          label="Data de alteração"
          sxStyle={{ opacity: "", pointerEvents: "auto", margin: 0, }}
          type="date"
          fullWidth
          value={valuesInputCancelarContrato.date}
          onChange={handleChange("date")}
          variant="outlined"
        />
      </Grid>

      <Grid item xs={7}>
        <AppTextField
          select
          label="Status"
          value={valuesInputCancelarContrato.status}
          onChange={handleChange("status")}
          variant="outlined"
          sxStyle={{ opacity: "", pointerEvents: "auto", margin: 0 }}
          fullWidth
          SelectProps={{
            renderValue: (selected) => {
              const opt = STATUS_SELECT_OPTIONS.find((o) => o.value === selected);
              if (!opt) return String(selected);
              return menuItemWithIcon(opt);
            },
          }}
        >
          {STATUS_SELECT_OPTIONS.map((opt) => (
            <MenuItem key={opt.value} value={opt.value}>
              {menuItemWithIcon(opt)}
            </MenuItem>
          ))}
        </AppTextField>
      </Grid>

      <Grid item xs={12}>
        <AppTextField
          label="Descrição"
          sxStyle={{ opacity: "", pointerEvents: "auto", margin: 0, }}
          fullWidth
          value={valuesInputCancelarContrato.description}
          onChange={handleChange("description")}
          variant="outlined"
        />
      </Grid>
    </Grid>
  );
};
